// @ts-nocheck
import React, { createContext, useContext } from 'react';
import { useShipMethods } from '@/hooks/query';

const ShipMethodsContext = createContext();

function ShipMethodsProvider({ ...props }) {
  const { data: shipMethods, isLoading: isShipMethodsLoading } = useShipMethods();

  const state = { shipMethods, isShipMethodsLoading };

  return <ShipMethodsContext.Provider value={state} {...props} />;
}

const useShipMethodsContext = () => useContext(ShipMethodsContext);

export { ShipMethodsProvider, useShipMethodsContext };